/*
WO does not cover AF, AD, AR, BS, BD, BM, BT, BO, BI, CV,        ET, FJ, GY, HT, LB, MU, MM, NR, NP, PK, PY, RW, SB, SO, SS, SR, TW, TO, UY, VU, VA, VE, WS, YE										
HK can be obtained via China, direct and Europe (in some cases -see below), please pretend it can always as long as EP has not been granted yet)										
EP covers: AL, AT, BE, BG, CH, CY, CZ, DE, DK, EE, ES, FI, FR, GB, GE, GR, HR, HU, IE, IS, IT, KH, LA, LI, LT, LU, LV, MA, MC, MD, ME, MK, MT, NL, NO, PL, PT, RO, RS, SE, SI, SK, SM, TN, TR										
*In this example the EP patent is granted broader in EP than the current scope of WO and TW. That is why Vario is covered by EP and not the other										
*/

import { eaCountries, epCountries } from "src/data";
import { Member } from "src/patents/patents";

export function does_patent_cover_income(patent: Member, incomeCountry: string): boolean {
  const patentCountry = patent.countryCode;
  // TODO: should we check the status or not? What about "old" data (when patent was still granted)
  if (patentCountry === incomeCountry) {
    return true;
  } else if (patentCountry === 'WO') {
    return !countries_not_covered_by_wo.has(incomeCountry);
  } else if (incomeCountry === 'HK') {
    return patentCountry === 'CN' || (patentCountry === 'EP') // && patent.familyMemberStatus !== 'granted' && patent.familyMemberStatus !== 'stopped');
  } else if (patentCountry === 'EP') {
    return epCountries.includes(incomeCountry);
  } else if (patentCountry === 'EA') {
    return eaCountries.includes(incomeCountry);
  }
  return false;
}


const countries_not_covered_by_wo = new Set([
  'AF',
  'AD',
  'AR',
  'BS',
  'BD',
  'BM',
  'BT',
  'BO',
  'BI',
  'CV',
  'ET',
  'FJ',
  'GY',
  'HT',
  'LB',
  'MU',
  'MM',
  'NR',
  'NP',
  'PK',
  'PY',
  'RW',
  'SB',
  'SO',
  'SS',
  'SR',
  'TW',
  'TO',
  'UY',
  'VU',
  'VA',
  'VE',
  'WS',
  'YE',
])